import { render, staticRenderFns } from "./TarefaMovimentacao.vue?vue&type=template&id=43477e3c"
import script from "./TarefaMovimentacao.vue?vue&type=script&lang=js"
export * from "./TarefaMovimentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports